import React, { useEffect, useState, useRef, useCallback } from "react";
import '../../../assets/css/NewIncident.css';
import '../../../App.css';

import widgets from '../../../config/category_widgets.json';
import thirdDropdowns from '../../../config/incident_third_dropdowns';
import { createIncident, getLocationData } from "../../../utils/AWSAPI";
import LoadingSpinner from "../../../utils/LoadingSpinner";
import { serializeFile, submitAttachments } from "../../../utils/Utils";
import { useTranslation } from 'react-i18next';
import i18next from "i18next";
import i18n from "../../Translations/i18n/i18n";  //import i18next
import DOMPurify from 'dompurify';
import { useMemo } from "react";

import AttachmentPicker from "../../AttachmentsPicker";

function Banner({ label }) {
  const sanitizedLabel = DOMPurify.sanitize(label, {
    ALLOWED_TAGS: ['a', 'p', 'br'],
    ALLOWED_ATTR: ['href', 'target', 'rel']
  });

  return (
    <div className="banner-container">
      <p dangerouslySetInnerHTML={{ __html: sanitizedLabel }} />
    </div>
  );
}

function RadioGroup({ widget, label, options, selectedValue, required, onValueChange }) {
  const handleChange = (option) => {
    onValueChange(widget, option);
  };

  return (
    <div className="radio-container">
      <label className={required ? "required" : ""}>{label}</label>
      <div className="radio-options">
        {options.map((option) => (
          <div key={option} className="radio-option">
            <input
              type="radio"
              id={`${widget}_${option}`}
              name={widget}
              value={option}
              checked={selectedValue === option}
              onChange={() => handleChange(option)}
              required={required && !selectedValue}
            />
            <label htmlFor={`${widget}_${option}`}>{option}</label>
          </div>
        ))}
      </div>
    </div>
  );
}

function TextArea({ widget, label, value, required, onValueChange }) {
  const handleChange = (event) => {
    onValueChange(widget, event.target.value);
  };

  return (
    <div className="textArea-container">
      <p className={required ? "required" : ""}>{label}</p>
      <textarea
        cols={5}
        required={required}
        value={value || ""}
        onChange={handleChange}
      />
    </div>
  );
}

function Text({ widget, label, value, required, onValueChange }) {
  const handleChange = (event) => {
    onValueChange(widget, event.target.value);
  };

  return (
    <div className="text-container">
      <p className={required ? "required" : ""}>{label}</p>
      <input
        type="text"
        required={required}
        value={value || ""}
        onChange={handleChange}
      />
    </div>
  );
}

function Attachment({ label, required }) {
  return (
    <div className="attachment-container">
      <p className={required ? "required" : ""}>{label}</p>
      <input type="file" required={required} accept=".png, .pdf" />
    </div>
  );
}
function NewIncident() {

  const { t } = useTranslation();

  // DATA API
  const [isLoading, setLoading] = useState(true);
  const [isSubmitting, setSubmitting] = useState(false);
  const [data, setData] = useState(null);

  //Hotfix for empty submits
  const [selectedCategory, setSelectedCategory] = useState("Error");
  const [selectedSubcategory, setSelectedSubcategory] = useState("Error");
  const [selectedThirdOption, setSelectedThirdOption] = useState("Error");

  const [activeWidgets, setActiveWidgets] = useState([]);

  const [formValues, setFormValues] = useState({
    contact_name: "",
    callback_number: "",
    otherInformation: "",
  });
  const [usedWidgets, setUsedWidgets] = useState([]);

  // Are we showing a modal? I.E: Error, success.
  const [isModalShowing, setModalShowing] = useState(false);
  const [isModalUncloseable, setModalUncloseable] = useState(false);

  const [modalHeader, setModalHeader] = useState('Loading...');
  const [modalBody, setModalBody] = useState(<></>);
  const [modalFooter, setModalFooter] = useState(<></>);




  // Labels for each widget. Not to be confused with the actual values.
  //Hotfix for 
  const [id_banner_1, setIdBanner1] = useState('');
  const [id_banner_2, setIdBanner2] = useState('');
  const [id_banner_3, setIdBanner3] = useState('');
  const [id_banner_4, setIdBanner4] = useState('');
  const [id_banner_5, setIdBanner5] = useState('');
  const [id_banner_6, setIdBanner6] = useState('');

  const [id_yes_no_1, setIdYesNo1] = useState('');
  const [id_yes_no_2, setIdYesNo2] = useState('');
  const [id_yes_no_3, setIdYesNo3] = useState('');
  const [id_yes_no_4, setIdYesNo4] = useState('');
  const [id_yes_no_5, setIdYesNo5] = useState('');
  const [id_textarea_1, setIdTextArea1] = useState('');
  const [id_textarea_2, setIdTextArea2] = useState('');
  const [id_textarea_3, setIdTextArea3] = useState('');
  const [id_text_1, setIdText1] = useState('');
  const [id_text_2, setIdText2] = useState('');
  const [id_text_3, setIdText3] = useState('');
  const [id_text_4, setIdText4] = useState('');
  const [id_attachment_1, setIdAttachment1] = useState('');

  // The value of each widget's field.
  const [id_yes_no_1_value, setIdYesNo1Value] = useState('');
  const [id_yes_no_2_value, setIdYesNo2Value] = useState('');
  const [id_yes_no_3_value, setIdYesNo3Value] = useState('');
  const [id_yes_no_4_value, setIdYesNo4Value] = useState('');
  const [id_yes_no_5_value, setIdYesNo5Value] = useState('');
  const [id_textarea_1_value, setIdTextArea1Value] = useState('');
  const [id_textarea_2_value, setIdTextArea2Value] = useState('');
  const [id_textarea_3_value, setIdTextArea3Value] = useState('');
  const [id_text_1_value, setIdText1Value] = useState('');
  const [id_text_2_value, setIdText2Value] = useState('');
  const [id_text_3_value, setIdText3Value] = useState('');
  const [id_text_4_value, setIdText4Value] = useState('');
  const [id_attachment_1_value, setIdAttachment1Value] = useState('');

  // Whether if the widget is required or not ("isNotRequired" is a valid attribute in our widget configuration file (widgets.json))
  const [id_yes_no_1_required, setIdYesNo1Required] = useState(true);
  const [id_yes_no_2_required, setIdYesNo2Required] = useState(true);
  const [id_yes_no_3_required, setIdYesNo3Required] = useState(true);
  const [id_yes_no_4_required, setIdYesNo4Required] = useState(true);
  const [id_yes_no_5_required, setIdYesNo5Required] = useState(true);
  const [id_textarea_1_required, setIdTextArea1Required] = useState(true);
  const [id_textarea_2_required, setIdTextArea2Required] = useState(true);
  const [id_textarea_3_required, setIdTextArea3Required] = useState(true);
  const [id_text_1_required, setIdText1Required] = useState(true);
  const [id_text_2_required, setIdText2Required] = useState(true);
  const [id_text_3_required, setIdText3Required] = useState(true);
  const [id_text_4_required, setIdText4Required] = useState(true);
  const [id_attachment_1_required, setIdAttachment1Required] = useState(true);


  const [attachmentFiles, setAttachmentFiles] = useState([]); // validated+converted files from AttachmentPicker
  const [optionalAttachmentRows, setOptionalAttachmentRows] = useState([]);
  const [requiredAttachmentRows, setRequiredAttachmentRows] = useState({});
  const [attachmentsBusy, setAttachmentsBusy] = useState(false);
  const [attachmentsValid, setAttachmentsValid] = useState(true);
  const optionalAttachmentRef = useRef(null);
  const requiredAttachmentRefs = useRef({});



  const resetWidgets = () => {
    // Reset widget labels
    setIdBanner1('');
    setIdBanner2('');
    setIdBanner3('');
    setIdBanner4('');
    setIdBanner5('');
    setIdBanner6('');
    setIdYesNo1('');
    setIdYesNo2('');
    setIdYesNo3('');
    setIdYesNo4('');
    setIdYesNo5('');
    setIdTextArea1('');
    setIdTextArea2('');
    setIdTextArea3('');
    setIdText1('');
    setIdText2('');
    setIdText3('');
    setIdText4('');
    setIdAttachment1('');

    // Reset widget values
    setIdYesNo1Value('');
    setIdYesNo2Value('');
    setIdYesNo3Value('');
    setIdYesNo4Value('');
    setIdYesNo5Value('');
    setIdTextArea1Value('');
    setIdTextArea2Value(''); // <-- CAMBIO: Reset del valor del nuevo campo
    setIdTextArea3Value('');
    setIdText1Value('');
    setIdText2Value('');
    setIdText3Value('');
    setIdText4Value('');
    setIdAttachment1Value('');

    setUsedWidgets([]);
  }

  const getWidgetConfig = (category, subcategory) => {
    if (!category || category === "Error") return [];

    if (category === "Back Office") {
      return widgets?.[category]?.[subcategory] || [];
    }

    return widgets?.[category] || [];
  };

  const normalizeWidgetConfig = (config = []) => {
    const labelKey = i18next.language === "fq" ? "labelFr" : "label";

    return config.map((widget) => ({
      id: widget.widget,
      type: widget.widget,
      label: widget[labelKey] || "",
      required: !widget.isNotRequired,
      raw: widget,
    }));
  };

  const resetDynamicForm = () => {
    setActiveWidgets([]);

    setFormValues((prev) => ({
      contact_name: prev.contact_name || "",
      callback_number: prev.callback_number || "",
      otherInformation: prev.otherInformation || "",
    }));
  };

  const handleCategoryChange = (event) => {
    const nextCategory = event.target.value;

    setSelectedCategory(nextCategory);
    setSelectedSubcategory("Error");
    setSelectedThirdOption("Error");
    setRequiredAttachmentRows({});

    setActiveWidgets([]);

    setFormValues((prev) => ({
      contact_name: prev.contact_name || "",
      callback_number: prev.callback_number || "",
      otherInformation: prev.otherInformation || "",
    }));
  };

  const handleSubcategoryChange = (event) => {
    const nextSubcategory = event.target.value;
    const config = getWidgetConfig(selectedCategory, nextSubcategory);
    const normalized = normalizeWidgetConfig(config);

    setSelectedSubcategory(nextSubcategory);
    setSelectedThirdOption("Error");
    setRequiredAttachmentRows({});
    setActiveWidgets(normalized);

    setFormValues((prev) => {
      const nextValues = {
        contact_name: prev.contact_name || "",
        callback_number: prev.callback_number || "",
        otherInformation: prev.otherInformation || "",
      };

      normalized.forEach((widget) => {
        nextValues[widget.id] = "";
      });

      return nextValues;
    });
  };



  const handleFilesChange = useCallback((files, rows) => {
    setAttachmentFiles(files);
    setOptionalAttachmentRows(rows || []);

    const busy = (rows || []).some(
      (r) => r.status === "converting" || r.status === "loading"
    );

    const valid = (rows || []).every((r) => r.status === "success");

    setAttachmentsBusy(busy);
    setAttachmentsValid(rows?.length ? valid : true);
  }, []);

  const getThirdOptions = (category = selectedCategory, subcategory = selectedSubcategory) =>
    thirdDropdowns?.[category]?.[subcategory] || [];

  const getSelectedThirdConfig = () =>
    getThirdOptions().find((option) => option.label === selectedThirdOption) || null;

  const getThirdFields = () => {
    const config = getSelectedThirdConfig();
    if (!config) return [];
    return i18next.language === "fq" ? config.fieldsFr || config.fields : config.fields || [];
  };

  const handleThirdOptionChange = (event) => {
    const nextOption = event.target.value;
    const config = getThirdOptions().find((option) => option.label === nextOption);
    const fields = i18next.language === "fq" ? config?.fieldsFr || config?.fields : config?.fields || [];

    setSelectedThirdOption(nextOption);
    setRequiredAttachmentRows({});
    setFormValues((prev) => {
      const nextValues = { ...prev };
      fields.forEach((field) => {
        if (field.type !== "attachment" && field.type !== "note") {
          nextValues[`third_${field.key}`] = "";
        }
      });
      return nextValues;
    });
  };

  const handleRequiredAttachmentChange = useCallback((fieldKey, files, rows) => {
    setRequiredAttachmentRows((prev) => ({
      ...prev,
      [fieldKey]: rows || [],
    }));
  }, []);

  const allAttachmentRows = useMemo(() => [
    ...Object.entries(requiredAttachmentRows).flatMap(([fieldKey, rows]) =>
      (rows || []).map((row) => ({ ...row, fieldKey, source: "required" }))
    ),
    ...(optionalAttachmentRows || []).map((row) => ({ ...row, source: "optional" })),
  ], [optionalAttachmentRows, requiredAttachmentRows]);

  useEffect(() => {
    const busy = allAttachmentRows.some((r) => r.status === "converting" || r.status === "loading");
    const valid = allAttachmentRows.every((r) => r.status === "success");

    setAttachmentsBusy(busy);
    setAttachmentsValid(allAttachmentRows.length ? valid : true);
  }, [allAttachmentRows]);

  const handleValueChange = (field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const validateDynamicWidgets = () => {
    for (const widget of activeWidgets) {
      if (!widget.required) continue;
      if (widget.id.startsWith("id_banner_")) continue;

      const value = formValues[widget.id];

      if (widget.id.startsWith("id_yes_no_")) {
        if (!value) {
          return `Missing required field: ${widget.label}`;
        }
        continue;
      }

      if (widget.id.startsWith("id_attachment_")) {
        if (!value) {
          return `Missing required field: ${widget.label}`;
        }
        continue;
      }

      if (String(value || "").trim() === "") {
        return `Missing required field: ${widget.label}`;
      }
    }

    return null;
  };

  const validateThirdOptionFields = () => {
    const thirdOptions = getThirdOptions();
    if (thirdOptions.length > 0 && (!selectedThirdOption || selectedThirdOption === "Error")) {
      return "Missing required field: third dropdown";
    }

    const fields = getThirdFields();
    for (const field of fields) {
      if (!field.isRequired) continue;

      if (field.type === "attachment") {
        const rows = requiredAttachmentRows[`third_${field.key}`] || [];
        if (!rows.some((row) => row.status === "success" && row.file)) {
          return `Missing required attachment: ${field.label}`;
        }
        continue;
      }

      if (String(formValues[`third_${field.key}`] || "").trim() === "") {
        return `Missing required field: ${field.label}`;
      }
    }

    return null;
  };

  const widgetStateMap = {
    "id_yes_no_1": [id_yes_no_1_value, id_yes_no_1_required],
    "id_yes_no_2": [id_yes_no_2_value, id_yes_no_2_required],
    "id_yes_no_3": [id_yes_no_3_value, id_yes_no_3_required],
    "id_yes_no_4": [id_yes_no_4_value, id_yes_no_4_required],
    "id_yes_no_5": [id_yes_no_5_value, id_yes_no_5_required],
    "id_textarea_1": [id_textarea_1_value, id_textarea_1_required],
    "id_textarea_2": [id_textarea_2_value, id_textarea_2_required], // <-- CAMBIO
    "id_textarea_3": [id_textarea_3_value, id_textarea_3_required],
    "id_text_1": [id_text_1_value, id_text_1_required],
    "id_text_2": [id_text_2_value, id_text_2_required],
    "id_text_3": [id_text_3_value, id_text_3_required],
    "id_text_4": [id_text_4_value, id_text_4_required],
    "id_attachment_1": [id_attachment_1_value, id_attachment_1_required],
  };

  const widgetPairingMap = {
    "id_yes_no_1": [id_yes_no_1, id_yes_no_1_value],
    "id_yes_no_2": [id_yes_no_2, id_yes_no_2_value],
    "id_yes_no_3": [id_yes_no_3, id_yes_no_3_value],
    "id_yes_no_4": [id_yes_no_4, id_yes_no_4_value],
    "id_yes_no_5": [id_yes_no_5, id_yes_no_5_value],
    "id_textarea_1": [id_textarea_1, id_textarea_1_value],
    "id_textarea_2": [id_textarea_2, id_textarea_2_value], // <-- CAMBIO
    "id_textarea_3": [id_textarea_3, id_textarea_3_value],
    "id_text_1": [id_text_1, id_text_1_value],
    "id_text_2": [id_text_2, id_text_2_value],
    "id_text_3": [id_text_3, id_text_3_value],
    "id_text_4": [id_text_4, id_text_4_value],
    "id_attachment_1": [id_attachment_1, id_attachment_1_value],
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (attachmentsBusy) {
      return updateModal("Error", "Please wait until all attachments finish validating.");
    }

    if (!attachmentsValid) {
      return updateModal("Error", "One or more attachments are invalid. Please remove/replace the failed file(s).");
    }

    if (
      selectedCategory === "" ||
      selectedCategory === "Error" ||
      selectedSubcategory === "" ||
      selectedSubcategory === "Error"
    ) {
      return updateModal("Error", "You're missing required fields, please choose a subcategory and then try again.");
    }

    const widgetValidationError = validateDynamicWidgets();
    if (widgetValidationError) {
      return updateModal("Error", widgetValidationError);
    }

    const thirdValidationError = validateThirdOptionFields();
    if (thirdValidationError) {
      return updateModal("Error", thirdValidationError);
    }

    setSubmitting(true);
    submitIncident();
  };

  const getFullDescription = () => {
    const fields = [];

    fields.push(
      "Preferred Contact Name:\n" +
      (formValues.contact_name?.trim() || "None provided.") +
      "\n\n"
    );

    activeWidgets.forEach((widget) => {
      if (widget.id.startsWith("id_banner_")) return;

      const value = formValues[widget.id];
      const trimmedValue = String(value || "").trim();

      if (trimmedValue !== "") {
        fields.push(widget.label + "\n" + trimmedValue + "\n\n");
      } else if (widget.required) {
        fields.push(widget.label + "\n[MISSING REQUIRED VALUE]\n\n");
      }
    });

    if (selectedThirdOption && selectedThirdOption !== "Error") {
      fields.push("Issue Type\n" + selectedThirdOption + "\n\n");

      getThirdFields().forEach((field) => {
        if (field.type === "note") {
          fields.push(field.label + "\n\n");
          return;
        }

        if (field.type === "attachment") {
          const names = (requiredAttachmentRows[`third_${field.key}`] || [])
            .filter((row) => row.status === "success" && row.file)
            .map((row) => row.file.name)
            .join(", ");

          fields.push(field.label + "\n" + (names || "No attachment provided.") + "\n\n");
          return;
        }

        const value = String(formValues[`third_${field.key}`] || "").trim();
        if (value !== "") {
          fields.push(field.label + "\n" + value + "\n\n");
        } else if (field.isRequired) {
          fields.push(field.label + "\n[MISSING REQUIRED VALUE]\n\n");
        }
      });
    }

    fields.push(
      "Other Information\n" +
      (formValues.otherInformation?.trim() || "None provided.")
    );

    return fields.join("");
  };

  const formatWord = (s = "") =>
    String(s)
      .trim()
      .toLowerCase()
      .replace(/[\(\)]/g, "")
      .replace(/[\s\/-]+/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "");

  const CATEGORY_EXCEPTIONS = {
    "Live Store (Camera System)": "live_store",
  };

  const SUBCATEGORY_EXCEPTIONS_BY_CATEGORY = {
    cashless: {
      "DT": "drive_thru",
      "FC": "front_counter",
    },

    digital_menu_board: {
      "DT Pricing": "dmb_dt_pricing",
      "FC Hardware": "dmb_fc_hardware",
      "FC Content": "dmb_fc_content",
      "DT Content": "dmb_dt_content",
      "COD": "dmb_cod",
      "DT Hardware": "dmb_dt_hardware",
      "FC Pricing": "dmb_fc_pricing",
    },

    pos_sesame: {
      "Automatic Beverage System": "abs",
      "COD Everbright": "cod",
      "RMU": "rmu",
      "RFM": "rfm",
    },


  };


  const getValidCategory = () => {
    const category = selectedCategory || "";
    return CATEGORY_EXCEPTIONS[category] || formatWord(category);
  };

  const getValidSubcategory = () => {
    const subcategory = selectedSubcategory || "";
    const categoryFormatted = getValidCategory();

    const categoryMap = SUBCATEGORY_EXCEPTIONS_BY_CATEGORY[categoryFormatted] || {};
    return categoryMap[subcategory] || formatWord(subcategory);
  };




  const submitIncident = async () => {
    try {
      const description = getFullDescription();

      const incident = await createIncident(
        "",
        getValidCategory(),
        getValidSubcategory(),
        data.CallerEmail,
        formValues.contact_name?.trim() || data.Name,
        formValues.callback_number?.trim() || "Unspecified",
        "4",
        "4",
        selectedThirdOption && selectedThirdOption !== "Error"
          ? selectedCategory + " - " + selectedSubcategory + " - " + selectedThirdOption
          : selectedCategory + " - " + selectedSubcategory,
        description
      );

      if (incident.Error) {
        console.log(incident.Error);
        setSubmitting(false);
        return updateModal("Error", incident.Error);
      }

      const sysId = incident.SysID;
      const caseNumber = incident.Result;
      const requiredFiles = Object.values(requiredAttachmentRows)
        .flat()
        .filter((row) => row.status === "success" && row.file)
        .map((row) => row.file);
      const okFiles = [...requiredFiles, ...(attachmentFiles || [])];

      if (okFiles.length === 0) {
        setModalUncloseable(true);
        updateModal(
          "Success",
          "Incident created successfully. Incident Number: " +
          incident.Result +
          ". \n\nPlease wait..."
        );
        setSubmitting(false);

        setTimeout(() => {
          window.location.href = `incident?ticketNumber=${caseNumber}`;
        }, 1000);

        return;
      }

      const uploadResults = [];

      for (const file of okFiles) {
        try {
          const serialized = await serializeFile(file);
          const res = await submitAttachments(sysId, serialized ? [serialized] : []);

          uploadResults.push({
            name: file.name,
            ok: !res?.Error,
            details: res?.Detail || res?.Message || res?.Error || "",
          });
        } catch (e) {
          uploadResults.push({
            name: file.name,
            ok: false,
            details: e?.message || "Upload failed.",
          });
        }
      }

      const failedUploads = uploadResults.filter((r) => !r.ok);

      setModalUncloseable(true);

      let modalText =
        "Incident created successfully. Incident Number: " +
        incident.Result +
        ".\n\n";

      if (failedUploads.length > 0) {
        modalText += "Attachments:\n";
        modalText += uploadResults
          .map((r) =>
            r.ok
              ? ` ${r.name}: uploaded`
              : ` ${r.name}: failed (${r.details || "Unknown error"})`
          )
          .join("\n");
        modalText += "\n\nPlease wait...";
      } else {
        modalText += "Attachments uploaded successfully.\n\nPlease wait...";
      }

      updateModal("Success", modalText);
      setSubmitting(false);

      const redirectDelayMs = failedUploads.length > 0 ? 10000 : 1000;
      setTimeout(() => {
        window.location.href = `incident?ticketNumber=${caseNumber}`;
      }, redirectDelayMs);
    } catch (err) {
      console.log(err);
      setSubmitting(false);
      updateModal("Error", err?.message || "An unexpected error occurred.");
    }
  };

  const Modal = () => {
    return (
      <div className="modal show">
        <div className="modal-content">
          <div className="modal-header">
            <h4>{modalHeader}</h4>
            {!isModalUncloseable && (
              <span className="close" onClick={closeModal}>&times;</span>
            )}
          </div>
          <div className="modal-body">{modalBody}</div>
          <div className="modal-footer">{modalFooter}</div>
        </div>
      </div>
    );
  };




  useEffect(() => {
    setSelectedCategory("Error");
    setSelectedSubcategory("Error");

    resetWidgets();
    setDefaultAttributes();
  }, [])

  const updateModal = (header, body, footer) => {
    setModalShowing(!isModalShowing);
    setModalHeader(header);
    setModalBody(body);
    setModalFooter(footer);
  }

  const closeModal = () => {
    setModalShowing(false);
  };

  const setDefaultAttributes = async () => {
    const url = new URL(window.location.href);
    const locationValue = url.searchParams.get('location');
    const locationNameValue = url.searchParams.get('locationName');

    if (!locationValue) {
      updateModal("Whoops!", "It seems you've accessed this page without choosing a valid location first. Please access the Restaurants page in order to fix this error.")
      return { success: false };
    } else {
      return { success: true, location: locationValue, locationName: locationNameValue };
    }
  }

  const removeAttachmentRow = (row) => {
    if (row.source === "required") {
      requiredAttachmentRefs.current[row.fieldKey]?.removeAt(row.id);
      return;
    }

    optionalAttachmentRef.current?.removeAt(row.id);
  };

  useEffect(() => {
    const loadLanguage = () => {
      const language = localStorage.getItem("language");
      if (language) {
        i18n.changeLanguage(language);
      }
    };
    loadLanguage();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { success, location: fetchedLocation, locationName: fetchedName } = await setDefaultAttributes();
        if (success) {
          const locationData = await getLocationData(fetchedLocation);
          if (locationData.Error) {
            return updateModal("Error", locationData.Error)
          } else {
            setData(locationData);
            setLoading(false);
          }
        } else {
          console.log("Invalid location. Not calling API.");
        }
      } catch (err) {
        console.log(err);
      }
    };
    if (isLoading) {
      fetchData();
    }
  }, [isLoading]);

  return (
    <div className="App">
      <LoadingSpinner show={isLoading || isSubmitting} />

      {isModalShowing && (
        <Modal />
      )}

      {data && (
        <form onSubmit={handleSubmit}>
          <div className="new-incidents-container">
            <div className="recuadro">
              <h1>
                {t('report_issue')}
              </h1>
              <hr />
              <br />
              <b>
                {t('please_note')}
                <br /><br />
                {t('critical_issues')}
                <br /><br />
                {t('response_time')}
                <br />
                {t('replacement_printer')}
              </b>
              <br /><br />
            </div>

            <div className="recuadro" >
              <label for="fname" className="required">{t('restaurant')}: </label>
              <input type="text" id="fname" name="fname" disabled placeholder={data.Name} value={data.Name} required />
              <br /><br />
              <label for="lname" className="required">{t('store_phone_number')}: </label>
              <input type="text" id="lname" name="lname" disabled placeholder={data.Phone} value={data.Phone} required />
              <br /><br />
              <label htmlFor="contact_name">{t('preferred_contact_name')}: </label>
              <input
                type="text"
                id="contact_name"
                name="contact_name"
                value={formValues.contact_name || ""}
                onChange={(e) => handleValueChange("contact_name", e.target.value)}
              />

              <br /><br />

              <label htmlFor="callback_number">{t('preferred_callback_number')}: </label>
              <input
                type="number"
                id="callback_number"
                name="callback_number"
                value={formValues.callback_number || ""}
                onChange={(e) => handleValueChange("callback_number", e.target.value)}
              />
              <br /><br />

              <label for="category" className="required">{t('issueRelatedTo')} </label>
              <select name="category" id="category" onChange={handleCategoryChange} value={selectedCategory} required>
                <option value="Error" disabled>{t('select_item')}</option>
                <option value="Back Office">{t('Back Office')}</option>
                <option value="Cashless">{t('Cashless')}</option>
                <option value="Clearview">{t('Clearview')}</option>
                <option value="Digital Menu Board">{t('Digital Menu Board')}</option>
                <option value="Food Safety">{t('Food Safety')}</option>
                <option value="Live Store (Camera System)">{t('Live Store (Camera System)')}</option>
                <option value="LSM-Blue Yonder">{t('LSM-Blue Yonder')}</option>
                <option value="McDelivery Door Dash">{t('McDelivery Door Dash')}</option>
                <option value="McDelivery Scale">{t('McDelivery Scale')}</option>
                <option value="McDelivery Skip The Dishes">{t('McDelivery Skip The Dishes')}</option>
                <option value="McDelivery Uber Eats">{t('McDelivery Uber Eats')}</option>
                <option value="Mobile Ordering App (GMA)">{t('Mobile Ordering App (GMA)')}</option>
                <option value="Network Cabinet">{t('Network Cabinet')}</option>
                <option value="POS (Sesame)">{t('POS (Sesame)')}</option>
                <option value="Self Service Portal">{t('Self Service Portal')}</option>
                <option value="Table Tracker">{t('Table Tracker')}</option>
                <option value="Digital Reader Board (DRB)">{t('Digital Reader Board (DRB)')}</option>
              </select>

              {selectedCategory && selectedCategory != "Error" && (
                <div className="extra-padding-left extra-padding-right">
                  <br />
                  <select name="subcategory" id="subcategory" onChange={handleSubcategoryChange} value={selectedSubcategory} required>
                    <option value="Error" disabled>{t('select_item')}</option>
                    {getSubcategoryList(selectedCategory).map((item, index) => (
                      <option key={index} value={item}>
                        {t(item)}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {getThirdOptions().length > 0 && (
                <div className="extra-padding-left extra-padding-right">
                  <br />
                  <label htmlFor="thirdOption" className="required">Issue Type: </label>
                  <select name="thirdOption" id="thirdOption" onChange={handleThirdOptionChange} value={selectedThirdOption} required>
                    <option value="Error" disabled>{t('select_item')}</option>
                    {getThirdOptions().map((item, index) => (
                      <option key={index} value={item.label}>
                        {i18next.language === "fq" ? item.labelFr || item.label : item.label}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {selectedThirdOption && selectedThirdOption !== "Error" && (
                <div className="recuadro">
                  <b>{t('provideInformation')}:</b>
                  <br />
                  <div className="extra-padding third-option-fields">
                    {getThirdFields().map((field) => {
                      const fieldKey = `third_${field.key}`;
                      const requiredClass = field.isRequired ? "required" : "";

                      if (field.type === "note") {
                        return (
                          <p className="third-option-note" key={fieldKey}>{field.label}</p>
                        );
                      }

                      if (field.type === "attachment") {
                        return (
                          <div className="third-option-field" key={fieldKey}>
                            <p className={requiredClass}>{field.label}</p>
                            <AttachmentPicker
                              ref={(node) => {
                                if (node) {
                                  requiredAttachmentRefs.current[fieldKey] = node;
                                } else {
                                  delete requiredAttachmentRefs.current[fieldKey];
                                }
                              }}
                              maxFiles={1}
                              validateInSnow={true}
                              tag={field.label}
                              buttonLabel="Submit attachment"
                              onFilesChange={(files, rows) => handleRequiredAttachmentChange(fieldKey, files, rows)}
                            />
                          </div>
                        );
                      }

                      if (field.type === "textarea") {
                        return (
                          <div className="third-option-field" key={fieldKey}>
                            <p className={requiredClass}>{field.label}</p>
                            <textarea
                              rows={3}
                              required={field.isRequired}
                              value={formValues[fieldKey] || ""}
                              onChange={(e) => handleValueChange(fieldKey, e.target.value)}
                            />
                          </div>
                        );
                      }

                      return (
                        <div className="third-option-field" key={fieldKey}>
                          <p className={requiredClass}>{field.label}</p>
                          <input
                            type="text"
                            required={field.isRequired}
                            value={formValues[fieldKey] || ""}
                            onChange={(e) => handleValueChange(fieldKey, e.target.value)}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {activeWidgets.length > 0 ? (
                <div
                  className="recuadro"
                  key={`${selectedCategory}__${selectedSubcategory}`}
                >
                  <b>{t('provideInformation')}:</b>
                  <br />
                  <div className="extra-padding">
                    {activeWidgets.map((widget) => {
                      if (!widget.label) return null;

                      if (widget.id.startsWith("id_banner_")) {
                        let bannerLabel = widget.label;

                        if (selectedCategory === "POS (Sesame)" && widget.id === "id_banner_2") {
                          bannerLabel = bannerLabel.replace(
                            /@MCD/g,
                            `<a href="https://www.atmcd.com/sites/canada/technology/SitePageModern/2638963/kvs-monitor-self-replacement-guide" target="_blank">@MCD</a>`
                          );
                        }

                        if (selectedCategory === "POS (Sesame)" && widget.id === "id_banner_6") {
                          bannerLabel = bannerLabel.replace(
                            /@MCD/g,
                            `<a href="https://www.atmcd.com/sites/canada/technology/SitePage/2606302/transition-from-ups-to-surge-protector" target="_blank">@MCD</a>`
                          );
                        }

                        return <Banner key={widget.id} label={bannerLabel} />;
                      }

                      if (widget.id.startsWith("id_yes_no_")) {
                        return (
                          <RadioGroup
                            key={widget.id}
                            widget={widget.id}
                            label={widget.label}
                            selectedValue={formValues[widget.id] || ""}
                            options={[t('Yes'), t('No'), t('N/A')]}
                            required={widget.required}
                            onValueChange={handleValueChange}
                          />
                        );
                      }

                      if (widget.id.startsWith("id_textarea_")) {
                        return (
                          <TextArea
                            key={widget.id}
                            widget={widget.id}
                            label={widget.label}
                            value={formValues[widget.id] || ""}
                            required={widget.required}
                            onValueChange={handleValueChange}
                          />
                        );
                      }

                      if (widget.id.startsWith("id_text_")) {
                        return (
                          <Text
                            key={widget.id}
                            widget={widget.id}
                            label={widget.label}
                            value={formValues[widget.id] || ""}
                            required={widget.required}
                            onValueChange={handleValueChange}
                          />
                        );
                      }

                      if (widget.id.startsWith("id_attachment_")) {
                        return (
                          <Attachment
                            key={widget.id}
                            label={widget.label}
                            required={widget.required}
                          />
                        );
                      }

                      return null;
                    })}
                  </div>
                </div>
              ) : null}

              <br /><br />
              <div className="recuadroextra">
                <div className="gris">
                  <h3>
                    {t('provideDetailedDesc')}
                  </h3>
                  <div className="izquierdoa">
                    <p>
                      <b>{t('besureClearly')}:</b>
                    </p>

                    <p>
                      &emsp;<b>•</b> {t('whatNotWorking')}
                      <br />
                      &emsp;<b>•</b> {t('specificErrorMessage')}
                      <br />
                      &emsp;<b>•</b> {t('troubleshootingAttempt')}
                      <br />
                      &emsp;<b>•</b> {t('specificIssue')}
                    </p>

                    <p>
                      {t('betterEquipped')}
                    </p>
                    <p>
                      {t('includeScreenshots')}
                    </p>
                  </div>
                </div>
              </div>

              <br />
              <label htmlFor="otherInformation">{t('otherInformationLabel')}</label>
              <textarea
                id="otherInformation"
                name="otherInformation"
                rows={10}
                value={formValues.otherInformation || ""}
                onChange={(e) => handleValueChange("otherInformation", e.target.value)}
              ></textarea>

              <br /><br />

              {/* Nota en inglés y francés, resaltada */}
              <div style={{
                backgroundColor: '#fffae6',
                border: '2px solid #ffa500',
                padding: '8px',
                marginBottom: '8px'
              }}>
                <p>
                  <strong>{t('attachmentDamageNote')}</strong>
                </p>
              </div>

              <label for="attachments">{t('addAttachmentsLabel')} {t('maximumAllowed')}: </label>
              <AttachmentPicker
                ref={optionalAttachmentRef}
                // maxFiles={5}
                validateInSnow={true}
                onFilesChange={handleFilesChange}
              />

              {allAttachmentRows.length > 0 && (
                <div className="attachments-summary">
                  {allAttachmentRows.map((row) => (
                    <div className="attachment-summary-row" key={`${row.source}-${row.id}`}>
                      <span>
                        {row.file?.name || row.originalName}
                        {row.tag ? ` (${row.tag})` : ""}
                      </span>
                      <button
                        type="button"
                        className="red-button"
                        onClick={() => removeAttachmentRow(row)}
                        disabled={row.status === "converting" || row.status === "loading"}
                      >
                        <b>Remove</b>
                      </button>
                    </div>
                  ))}
                </div>
              )}


              <br /><br />

              <hr />
              <button
                disabled={isSubmitting || attachmentsBusy || !attachmentsValid}
                className="red-button"
                type="submit"
              >
                <b>{t('submit_button')}</b>
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  );

  function getSubcategoryList(category) {
    if (typeof category == "undefined" || category == "") {
      return [];
    }

    switch (category) {
      case "Back Office":
        return ["IBOS PC", "Installed Applications", "Internet Applications", "Thoughtworks"];

      case "Call Back":
        return ["Status Update"];

      case "Cashless":
        return ["DT", "FC", "Kiosk"];

      case "Clearview":
        return ["Application", "Cash Sheet", "Employee", "Forecasting", "Import Export", "Inventory", "Labour Scheduling", "Martin Brower", "Payroll", "Reports", "User Access"];

      case "Digital Menu Board":
        return ["COD", "DT Content", "DT Hardware", "DT Pricing", "FC Content", "FC Hardware", "FC Pricing"];

      case "Food Safety":
        return ["iPad", "Pyrometer", "BrandMate"];

      case "Live Store (Camera System)":
        return ["Hardware", "Software"];

      case "LSM-Blue Yonder":
        return ["Configuration", "Hardware", "Integration-Data", "Log-in", "Time Punch Entry", "Reports"];

      case "McDelivery Door Dash":
        return ["Application", "Hardware", "Network", "Password", "POS Integration"];
      case "McDelivery Scale":
        return ["Application", "Hardware", "Network"];
      case "McDelivery Skip The Dishes":
        return ["Application", "Hardware", "MDM Enrollment", "Network", "Password", "POS Integration"];
      case "McDelivery Uber Eats":
        return ["Application", "Hardware", "Network", "Password", "POS Integration"];
      case "Miscellaneous":
        return ["Unsupported Call", "Hang Up", "Consumables", "Tech Call"];

      case "Mobile Ordering App (GMA)":
        return ["Adyen", "Check-in / Picking Up", "Digital Offers", "Loyalty", "Placing Orders"];
      case "Network Cabinet":
        return ["Hardware", "Network", "Outage", "Power"];
      case "POS (Sesame)":
        return ["Automatic Beverage System", "COD Everbright", "Coin Dispenser", "DT Camera", "KVS Grill Printer", "KVS Monitor", "KVS ORB Bump Bar", "KVS ORB Monitor", "KVS ORB Picklist Printer", "KVS ORB Thin Client", "KVS Thin Client", "KVS Touchscreen Monitor", "POS DT Printer", "POS DT Scanner", "POS DT Touchscreen", "POS FC Printer", "POS FC Scanner", "POS FC Touchscreen", "POS FOE", "POS Kiosk PC Box", "POS Kiosk", "POS Kiosk Printer", "POS Kiosk Scanner", "POS Kiosk Touchscreen", "POS Server", "RFM", "RMU", "Reports"];

      case "Self Service Portal":
        return ["AWS"];

      case "Table Tracker":
        return ["Radius Hardware", "Radius Network", "Radius TSS Monitor"];

      case "Digital Reader Board (DRB)":
        return ["Content", "Hardware", "Login"]

      default:
        return [];
    }
  }
}

export default NewIncident;
